<template>
<div id="HelpManual">
<!--  <el-container style="height: 500px; border: 1px solid #eee">-->
<!--    <el-header style="text-align: center; font-size: 12px">-->
<!--      <h1>CILICO 用户帮助文档</h1>-->
<!--      &lt;!&ndash;        <el-dropdown>&ndash;&gt;-->
<!--      &lt;!&ndash;          <i class="el-icon-setting" style="margin-right: 15px"></i>&ndash;&gt;-->
<!--      &lt;!&ndash;          <el-dropdown-menu slot="dropdown">&ndash;&gt;-->
<!--      &lt;!&ndash;            <el-dropdown-item>查看</el-dropdown-item>&ndash;&gt;-->
<!--      &lt;!&ndash;            <el-dropdown-item>新增</el-dropdown-item>&ndash;&gt;-->
<!--      &lt;!&ndash;            <el-dropdown-item>删除</el-dropdown-item>&ndash;&gt;-->
<!--      &lt;!&ndash;          </el-dropdown-menu>&ndash;&gt;-->
<!--      &lt;!&ndash;        </el-dropdown>&ndash;&gt;-->
<!--      &lt;!&ndash;        <span>王小虎</span>&ndash;&gt;-->
<!--    </el-header>-->

<!--    <el-container>-->
<!--      <el-aside width="200px" style="background-color: rgb(238, 241, 246);margin-top: 20px;">-->
<!--        <el-menu :default-openeds="['1', '3']">-->
<!--          <el-submenu index="1">-->
<!--            <template slot="title"><i class="el-icon-message"></i>导航一</template>-->
<!--            <el-menu-item-group>-->
<!--              <template slot="title">分组一</template>-->
<!--              <el-menu-item index="1-1">选项1</el-menu-item>-->
<!--              <el-menu-item index="1-2">选项2</el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--            <el-menu-item-group title="分组2">-->
<!--              <el-menu-item index="1-3">选项3</el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--            <el-submenu index="1-4">-->
<!--              <template slot="title">选项4</template>-->
<!--              <el-menu-item index="1-4-1">选项4-1</el-menu-item>-->
<!--            </el-submenu>-->
<!--          </el-submenu>-->
<!--          <el-submenu index="2">-->
<!--            <template slot="title"><i class="el-icon-menu"></i>导航二</template>-->
<!--            <el-menu-item-group>-->
<!--              <template slot="title">分组一</template>-->
<!--              <el-menu-item index="2-1">选项1</el-menu-item>-->
<!--              <el-menu-item index="2-2">选项2</el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--            <el-menu-item-group title="分组2">-->
<!--              <el-menu-item index="2-3">选项3</el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--            <el-submenu index="2-4">-->
<!--              <template slot="title">选项4</template>-->
<!--              <el-menu-item index="2-4-1">选项4-1</el-menu-item>-->
<!--            </el-submenu>-->
<!--          </el-submenu>-->
<!--          <el-submenu index="3">-->
<!--            <template slot="title"><i class="el-icon-setting"></i>导航三</template>-->
<!--            <el-menu-item-group>-->
<!--              <template slot="title">分组一</template>-->
<!--              <el-menu-item index="3-1">选项1</el-menu-item>-->
<!--              <el-menu-item index="3-2">选项2</el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--            <el-menu-item-group title="分组2">-->
<!--              <el-menu-item index="3-3">选项3</el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--            <el-submenu index="3-4">-->
<!--              <template slot="title">选项4</template>-->
<!--              <el-menu-item index="3-4-1">选项4-1</el-menu-item>-->
<!--            </el-submenu>-->
<!--          </el-submenu>-->
<!--        </el-menu>-->
<!--      </el-aside>-->
<!--      <el-main>-->
<!--        <el-table :data="tableData">-->
<!--          <el-table-column prop="date" label="日期" width="140">-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="name" label="姓名" width="120">-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="address" label="地址">-->
<!--          </el-table-column>-->
<!--        </el-table>-->
<!--      </el-main>-->
<!--    </el-container>-->
<!--  </el-container>-->
  <el-container>
    <el-header style="text-align: center">
      <h1>CILICO 用户帮助文档</h1>
    </el-header>
    <el-main>
      <el-row :gutter="24">
        <el-col :span="4">
          <mu-flex class="left_tree" direction="column" justify-content="between">
            <mu-flex direction="column" style="width:100%;">
              <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
            </mu-flex>
          </mu-flex>
        </el-col>
        <el-col :span="20">
            <mu-flex class="right_block" direction="column" style="width: 100%">
              <mu-paper class="custom-paper">
              </mu-paper>
            </mu-flex>
        </el-col>
      </el-row>
    </el-main>
  </el-container>

</div>
</template>

<script>
  export default {
    name: "HelpManual",
    data() {
      const item = {
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      };
      return {
        tableData: Array(20).fill(item),
        data: [{
          label: '一级 1',
          children: [{
            label: '二级 1-1',
            children: [{
              label: '三级 1-1-1'
            }]
          }]
        }, {
          label: '一级 2',
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
        defaultProps: {
          children: 'children',
          label: 'label',
        }
      }
    }
  }
</script>

<style>
  .left_tree {
    height: calc(100vh - 64px);
    background-color:rgba(255, 255, 255, 0.5);
    padding: 16px 8px;
    overflow: auto;
  }
  .right_block {
    height: calc(100vh - 64px);
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/HelpManual.vue